import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { ManageTagsDialogComponent } from '@tv3/containers/guests/dialogs/manage-tags/manage-tags-dialog.component'
import { Guest } from '@tv3/store/guest/guest.model'

@Injectable()
export class ManageTagsDialogService {
  constructor(private dialog: MatDialog) {}

  open(guest: Guest) {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { guest },
    }

    return this.dialog.open(ManageTagsDialogComponent, defaultConfig)
  }
}
